import { SPONSOR_TIER, CENTER_STATUS } from '@/domain/center'
export const POSTGRESS_ALGOLIA_MAPPINGS = {
  activity: 'activities',
  special_consideration: 'special_considerations',
  treatment_method: 'treatment_methods',
  treatment_therapy: 'treatment_therapies',
  personal_amenity: 'amenities',
  amenity: 'amenities',
  treatment_services: 'treatment_services',
  accepted_insurance: 'accepted_insurance',
  onsite_amenity: 'amenities',
  arranged_aftercare: 'aftercare',
  included_aftercare: 'aftercare',
  onsite_aftercare: 'aftercare',
  treatment_option: 'treatment_methods',
  condition: 'what_we_treat',
  clientele: 'who_we_treat',
  insurance: 'accepted_insurance',
  treatment_service: 'treatment_services'
}

export const MAX_HIT_COUNT = 15

export const baseStatusFilters = [
  `NOT status:${CENTER_STATUS.DRAFT}`,
  `NOT status:${CENTER_STATUS.HIDDEN}`,
  `NOT status:${CENTER_STATUS.CLOSED}`
]

export const baseSponsorFilterArray = [
  `sponsor_tier:${SPONSOR_TIER.GLOBAL}`,
  `sponsor_tier:${SPONSOR_TIER.REGIONAL}`
]

export const baseSponsorFilters: string = ''.concat(
  '(',
  baseSponsorFilterArray.join(' OR '),
  ')'
)
export const baseFilters = [
  baseStatusFilters.join(' AND '),
  baseSponsorFilters
].join(' AND ')

export const optionalFilters = [`site:lux<score=100>`, `site:samhsa<score=0>`]
